"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".host_104b31f2{display:inline}\n" }]);
exports.host = "host_104b31f2";
//# sourceMappingURL=TooltipHost.scss.js.map